import { variables } from 'swag-client-common/styles/variables-js';
const COLORS = {
  error: {
    border: '#ff3935',
    text: '#ff3935'
  },
  warning: {
    border: 'rgb(255, 150, 0)',
    text: 'rgb(255, 150, 0)'
  },
  active: {
    border: variables.colorMainBlue,
    text: variables.colorMainBlue
  },
  light: {
    border: 'rgb(224, 224, 224)',
    text: 'rgb(190,190,190)'
  },
  dark: {
    border: 'rgb(224, 224, 224)',
    text: 'rgb(190, 190, 190)'
  }
};
export default COLORS;